import React from 'react';

const Contact = () => {
    document.title ="Contact";
    return (
        <div>
            <h1> Contact Us</h1>
        </div>
    );
};

export default Contact;